

export type Column<T> = {
  key: keyof T;
  header: string;
  width?: string;
  align?: 'left' | 'center' | 'right';
  sortable?: boolean;
  sortDirection?: SortDirection;
  onSort?: (key: keyof T, direction: SortDirection) => void;
  Cell?: (row: T, rowIndex?: number) => React.ReactNode;
};

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}


